import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  TranscriptionApi,
  TranscriptionApiGetTranscriptionRequest,
  GetTranscription200Response,
} from '@/api/openapi';

export class TranscriptionApiService extends ApiService {
  api = new TranscriptionApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTranscription(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<TranscriptionApiGetTranscriptionRequest>,
  ): Promise<AxiosResponse<GetTranscription200Response>> {
    return this.checkResponse<GetTranscription200Response>(
      this.api.getTranscription(request, options),
      errorHandlers,
    );
  }
}
